import { useState } from "react";
import PassWord from "../../../Components/InputFields/PassWord";
import GradientBlue from "../../../Components/InputFields/GradientBlue";
import LogoWhite10 from "../../../Media/PNG/LogoWhite10.svg";
import LogoBlue from "../../../Media/PNG/LogoBlue.svg";
import Back from "./Back";

const isValidPassword = (password) =>
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/.test(password);

export default function ContainerForgotPWReset({ text, onBack, onSubmit }) {
  const logoSrc = document.documentElement.classList.contains("dark")
    ? LogoWhite10
    : LogoBlue;
  const [passwordData, setPasswordData] = useState({
    password: "",
    passwordAgain: "",
  });
  const [passwordBlur, setPasswordBlur] = useState(false);
  const [passwordAgainBlur, setPasswordAgainBlur] = useState(false);
  const [error, setError] = useState("");
  const passwordValid = isValidPassword(passwordData.password);
  const passwordAgainValid =
    passwordData.password !== "" &&
    passwordData.password === passwordData.passwordAgain;

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!passwordData.password || !passwordData.passwordAgain) {
      setError("لطفا تمامی فیلدها را پر کنید");
      return;
    }
    if (!passwordValid) {
      setError(
        "رمز عبور حداقل ۸ کاراکتر شامل عدد، حروف بزرگ و کوچک و کاراکتر ویژه باشد",
      );
      return;
    }
    if (!passwordAgainValid) {
      setError("رمز های عبور مطابقت ندارند");
      return;
    }
    setError("");
    onSubmit?.(passwordData.password);
  };

  return (
    <div className="w-full max-w-sm bg-zi-bg2-light dark:bg-zi-inputbg-dark/50 rounded-3xl p-5 gap-7 flex flex-col">
      <div className="flex flex-col gap-2 justify-center items-center">
        <div className="h-14">
          <img src={logoSrc} alt="لوگو" className="w-14" />
        </div>
        <p className="font-medium text-sm text-zi-text-light dark:text-zi-text-dark">
          کوژیتو فاند
        </p>
      </div>
      <div className="flex items-center justify-between gap-3">
        <h1 className="text-lg font-medium text-zi-text-light dark:text-zi-text-dark">
          {text}
        </h1>
        <Back onClick={onBack} />
      </div>
      <div>
        <form
          className="flex flex-col gap-5"
          autoComplete="off"
          onSubmit={handleSubmit}
        >
          <PassWord
            placeholder="رمز عبور جدید"
            id="new-password"
            formValue={passwordData.password}
            formOnChange={(event) => {
              setPasswordData({
                ...passwordData,
                password: event.target.value,
              });
              setError("");
            }}
            passwordBlur={passwordBlur}
            setPasswordBlur={setPasswordBlur}
            passwordValid={passwordValid}
            hasPassStrength={true}
          />
          <PassWord
            placeholder="تکرار رمز عبور جدید"
            id="new-password-confirmation"
            formValue={passwordData.passwordAgain}
            formOnChange={(event) => {
              setPasswordData({
                ...passwordData,
                passwordAgain: event.target.value,
              });
              setError("");
            }}
            passwordBlur={passwordAgainBlur}
            setPasswordBlur={setPasswordAgainBlur}
            passwordValid={passwordAgainValid}
          />
          <GradientBlue type="submit" value="ثبت رمز عبور جدید" />
        </form>
        {error && (
          <p className="text-amber-400 text-sm font-extralight mt-1">{error}</p>
        )}
      </div>
    </div>
  );
}
